// istanbul ignore file
import { useNavigate } from 'react-router-dom';
import { lazy } from 'react';

import { RemoteModule } from '../components/remote-module/remote-module';
import { modules } from '../components/side-menu/side-menu.constants';
import { useMessage } from '../i18n/useMessage';
import { UnicornApi } from '@cld/unicorn-api';

const defaultEventCategory = 'PM getting started use case classification';

const RemoteDeveloperGettingStarted = lazy(() =>
  import('@cld-remote/developer_getting_started/index').then(({ DeveloperGettingStartedPage }) => ({
    default: DeveloperGettingStartedPage,
  }))
);

export interface DeveloperGettingStartedProps {
  unicornApi: UnicornApi;
}

export const DeveloperGettingStarted = ({ unicornApi }: DeveloperGettingStartedProps) => {
  const { account, productEnvironment } = unicornApi.data;

  const t = useMessage();
  const navigate = useNavigate();

  return (
    <RemoteModule documentTitle={t('getting-started')}>
      <RemoteDeveloperGettingStarted
        unicornApi={unicornApi}
        key={productEnvironment.externalId /* FIXME: needed because GSP doesnt use data from outside in the end and relies on remount */}
        accountExternalId={account.externalId}
        splitKey={account.externalId}
        cloudName={productEnvironment.cloudName}
        customerExternalId={productEnvironment.externalId}
        accountCreationDate={account.__MIGRATION_createdAt}
        customerApiDataClient={() =>
          Promise.resolve({
            // TODO: Remove fallbacks when developer getting started page type is fixed
            apiKey: productEnvironment.apiKey || '',
            apiSecret: productEnvironment.apiSecret || '',
            cloudName: productEnvironment.cloudName,
          })
        }
        onTrack={({ eventAction, eventCategory = defaultEventCategory, eventLabel }) =>
          unicornApi.methods.sendAnalytics({
            variant: 'universal',
            data: { action: eventAction, category: eventCategory, label: eventLabel },
          })
        }
        onOpenVideoOverview={() => navigate(`../${modules.videoHub}`)}
        //TODO: @mckomo to check for solution on getting started
        onOpenTransformationBuilder={(parameters) =>
          navigate(
            `../${modules.transformationBuilder}${
              parameters ? `?transformationString=${parameters.transformationString}&publicId=${parameters.publicId}` : ''
            }`
          )
        }
        onOpenTransformationsCenter={(template) => navigate(`../${modules.transformationsCenter}/${template || ''}`)}
      />
    </RemoteModule>
  );
};
